import { Box, Container, HStack } from "@chakra-ui/react"
import * as _ from 'lodash-es'
import { useContext } from "react"
import { GameContext } from "../../GameContextF.jsx"
import { PtAck } from "../../../../componentsF/Chakra3F/ChakraF.jsx"
import { betInspect } from '../../../../sharedF/betInspectF.mts'
import { PtUndLink } from '../../../../componentsF/PtLinkF.jsx'
import { useAction } from "../../useAction.js"
import { GameContentCont } from "../../common/GenericGamePage.jsx"
import { getFePub } from "../../../../nextF/sharedF/getFePubF.mts"
import { durHumanAbs } from "../../../../sharedF/langF/dur2HumanF.mts"
import { SessIdCtx } from "../../../../componentsF/SessIdCtxF.tsx"
import { assertDefined } from "../../../../sharedF/assertsF/assertDefinedF.mts"

const ActionHistLine = ({
  ii, playerAction, actionAtDt, sessId, finishedTrails, actionAtMs,
  ...gameActionH
}) => {
  const {onClick, loading} = useAction({playerAction: 'gotoActionIdx', tgtActionIdx: ii})
  const sessIdCtx = useContext(SessIdCtx)
  assertDefined(sessIdCtx, {sessIdCtx})
  const {setSessId, sessId: mySessId} = sessIdCtx
  let {applyToIdx, gqActionsHistA} = useContext(GameContext)
  if (!_.isNumber(applyToIdx)) applyToIdx = gqActionsHistA.length
  // if (!actionAtDt) {
  //   betLog('2fj93fj39fj39fj', ii, gameActionH, playerAction)
  //   return
  // }

  const setNameActionA = _.filter(gqActionsHistA.slice(0, applyToIdx), ({playerAction, sessId: _sessId}) => {
    return playerAction == 'setPlayerAlias' && _sessId == sessId
  })

  const dur = actionAtDt.diff(gqActionsHistA[0].actionAtDt)
  const isActiveIdx = ii == applyToIdx

  return <HStack {...{}}>
    <Box {...{flexShrink: 0}}>
      {ii}
    </Box>
    {isActiveIdx ? <Box>curr</Box> : <PtUndLink {...{onClick}}>goto</PtUndLink>}
    <Box {...{flexShrink: 0}}>
      +{durHumanAbs(dur)} {playerAction}
    </Box>
    <HStack>
      {_.map(_.uniqBy(setNameActionA, 'sessId'), ({sessId, playerAlias}, key) => {
        const onClick = () => {
          setSessId(sessId)
          console.log('setSessId', {sessId, playerAlias})
        }
        const textDecor = mySessId == sessId ? 'underline' : ''
        return <Box key={key} {...{onClick, textDecor}}>{playerAlias}</Box>
      })}
    </HStack>
    <Box {...{textAlign: 'left'}}>
      {JSON.stringify(betInspect(gameActionH))}
    </Box>
  </HStack>
}

export const WrapRewindGame = ({children}) => {
  let {gqActionsHistA} = useContext(GameContext)

  if (!getFePub().isDev) {
    return <GameContentCont>{children}</GameContentCont>
  }

  return <HStack>
    <GameContentCont>
      {children}
    </GameContentCont>
    <Container {...{h: '800px', overflowY: 'scroll', alignSelf: 'flex-start', maxW: 'full'}}>
      <PtAck {...{spacing: 5, mt: 10}}>
        {_.map(gqActionsHistA, (gameActionH, ii) => {
          return <ActionHistLine key={ii} {...{ii, ...gameActionH}} />
        })}
      </PtAck>
    </Container>
  </HStack>
}